var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogonetflix(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 166 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7_32)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.1422 42.0994C20.6601 42.5393 18.1344 42.6712 15.5216 43.0224L7.55228 19.4679V44.0333C5.0702 44.2969 2.8058 44.6484 0.454224 45V0H7.07356L16.1312 25.5326V0H23.1422V42.0994ZM36.8596 16.4795C39.5597 16.4795 43.6966 16.3476 46.1787 16.3476V23.3787C43.0867 23.3787 39.4725 23.3787 36.8596 23.5106V33.9698C40.9532 33.7062 45.0466 33.3543 49.1834 33.2224V39.9896L29.8919 41.528V0H49.1834V7.03126H36.8596V16.4795ZM75.0938 7.03142H67.8651V39.3751C65.5135 39.3751 63.162 39.3751 60.8979 39.4628V7.03142H53.6691V0H75.0942L75.0938 7.03142ZM86.416 15.9962H95.953V23.0273H86.416V38.9797H79.5787V0H99.0448V7.03126H86.416V15.9962ZM110.367 32.8271C114.33 32.9148 118.336 33.2229 122.212 33.4423V40.3857C115.985 39.9899 109.757 39.595 103.4 39.4628V0H110.367V32.8271ZM128.091 40.8691C130.311 41.0012 132.663 41.1331 134.927 41.3963V0H128.091V40.8691ZM165.454 0L156.614 21.4014L165.454 45C162.841 44.6484 160.228 44.165 157.615 43.7255L152.608 30.718L147.513 42.6712C144.987 42.2313 142.548 42.0994 140.023 41.7479L148.994 21.1375L140.894 0H148.383L152.956 11.8213L157.833 0L165.454 0Z",
    fill: "#D81F26"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7_32"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 165,
    height: 45,
    fill: "white",
    transform: "translate(0.454224)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogonetflix);
export default __webpack_public_path__ + "static/media/logo netflix.fcf88ce9ad1bcb236b20978d94192bff.svg";
export { ForwardRef as ReactComponent };